var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 0H6C4.343 0 3 1.343 3 3V6H4.5V3C4.5 2.482 5.396 1.714 6 1.714H21C21.828 1.714 22.5 2.482 22.5 3V20.571C22.5 21.518 21.604 22.286 21 22.286H6C5.172 22.286 4.5 21.518 4.5 20.571V17.143H3V20.571C3 22.465 4.343 24 6 24H21C22.657 24 24 22.657 24 21V3C24 1.343 22.657 0 21 0ZM13.007 17.351C12.715 17.685 12.715 18.27 13.007 18.604C13.3 18.939 13.885 18.939 14.219 18.604L20.218 12.605C20.374 12.449 20.452 12.236 20.44 12.029C20.452 11.822 20.374 11.609 20.218 11.453L14.219 5.454C13.885 5.119 13.3 5.119 13.007 5.454C12.715 5.786 12.715 6.371 13.007 6.705L17.724 11.423H1C0.448 11.423 0 11.871 0 12.423C0 12.976 0.448 13.423 1 13.423H17.724L13.007 17.351Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatute);
export default __webpack_public_path__ + "static/media/statute.d1aaa8febcb3373e03ba75d5e41c85ad.svg";
export { ForwardRef as ReactComponent };